module.exports = __webpack_public_path__ + "img/close.779ce400.svg";